import { ComponentType } from '@angular/cdk/portal';
import { inject, Injectable, signal } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { TimeoutModalComponent } from '../components/timeout-modal/timeout-modal.component';
import { DialogOptions } from '../interfaces/modal-size';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  #dialog = inject(MatDialog)

  private _showLoadingModal = signal(false);
  private _timeoutDialogRef: MatDialogRef<TimeoutModalComponent, any> | null = null;
  private _modalRef: MatDialogRef<any> | null = null;

  readonly isLoadingModalVisible = this._showLoadingModal.asReadonly();

  hideLoadingIndicator(): void {
    this._showLoadingModal.set(false);
  }

  showLoadingIndicator(): void {
    this._showLoadingModal.set(true);
  }

  showTimeoutModal(): void {
    if (this._timeoutDialogRef) {
      this._timeoutDialogRef.close();
    }

    this._timeoutDialogRef = this.#dialog.open(TimeoutModalComponent, {
      closeOnNavigation: true,
      disableClose: true,
      height: '375px',
      width: '350px',
      position: { top: '20vh' }
    });
  }

  closeTimeoutModal(): void {
    if (this._timeoutDialogRef) {
      this._timeoutDialogRef.close();
    }
  }

  openModal<T>(component: ComponentType<T>, dialogData?: any, height?: string, width?: string): MatDialogRef<T> {
    this.closeModal();

    this._modalRef = this.#dialog.open<T>(component, {
      closeOnNavigation: true,
      disableClose: false,
      data: dialogData,
      height: height,
      width: width
    });

    return this._modalRef;
  }

  openModalWithOptions<T>(component: ComponentType<T>, dialogData?: any, options?: DialogOptions | MatDialogConfig): MatDialogRef<T> {
    this.closeModal();

    this._modalRef = this.#dialog.open<T>(component, {
      closeOnNavigation: true,
      disableClose: true,
      data: dialogData,
      height: options?.height,
      width: options?.width,
      maxHeight: options?.maxHeight ? options?.maxHeight : options.height,
      maxWidth: options?.maxWidth ? options?.maxWidth : options.width
    });

    return this._modalRef;
  }

  closeModal(results?: any): void {
    if (this._modalRef) {
      this._modalRef.close(results);
    }
  }

  closeAllModals(): void {
    const OPEN_MODALS = this.#dialog.openDialogs;
    if (Array.isArray(OPEN_MODALS)) {
      OPEN_MODALS.forEach(m => m.close());
    }
  }
}


